import { h } from 'preact'
import { Model, TableRow } from './types'
import { defaultCellSize } from './Table'

type Props = {
  id?: string,
  cells: TableRow,
  model?: Model[] | null,
  displayFirstColumnBold?: boolean
}

const Row = ({ id, cells, model, displayFirstColumnBold = false }: Props) =>
  <tr id={id ? cells[id] : null}>
    {model
      ? Object.keys(model).map((key: any) => {
        if (model[key].isHidden) {
          return
        }
        const { accessor, cell: customCell, size } = model[key]
        if (displayFirstColumnBold && key === '0') {
          return <th scope='row' className={`qa-${accessor} ${size || defaultCellSize}`}> {customCell ? customCell(cells) : accessor && cells[accessor]}</th>
        }
        return (
          <td className={`qa-${accessor} ${size || defaultCellSize}`}>
            {customCell ? customCell(cells) : accessor && cells[accessor]}
          </td>
        )
      })
      : Object.keys(cells).map((key) => {
        if (displayFirstColumnBold && key === '0' && !cells[key].colspan && cells[key].accessor !== 'tag-selector') {
          return <th scope='row' className={`qa-${cells[key].hasOwnProperty('accessor') ? cells[key].accessor : key} ${cells[key].size || defaultCellSize}`}>
            {cells[key].hasOwnProperty('cell') ? cells[key].cell : cells[key]}
          </th>
        }
        return (<td colSpan={cells[key].hasOwnProperty('colspan') ? cells[key].colspan : undefined}
          className={`qa-${cells[key].hasOwnProperty('accessor') ? cells[key].accessor : key} ${cells[key].size || defaultCellSize}`}>
          {cells[key].hasOwnProperty('cell') ? cells[key].cell : cells[key]}
        </td>)
      })
    }
  </tr>

export default Row
